import { apiGet } from './client';

export type AccountSignInMethod = 'apple' | 'email' | 'other';
export type AccountLastSignInMethod = 'passkey' | 'apple' | 'email';
export type AccountSignInFilter = 'apple' | 'email';
export type AccountSortField = 'createdAt' | 'lastSeen';
export type AccountSortOrder = 'asc' | 'desc';
export type AccountOrgRole = 'OWNER' | 'MANAGER' | 'STAFF';

export interface AdminAccountOrganization {
  id: string;
  name: string;
  role: AccountOrgRole;
  status: string;
}

export interface AdminAccountSubscription {
  originalTransactionId: string;
  productId: string | null;
  status: string | null;
  expiresAt: string | null;
}

/** One Check ID account, as GET /admin/users and GET /admin/users/:id return it. */
export interface AdminAccountRow {
  id: string;
  email: string | null;
  name: string | null;
  createdAt: string;
  signInMethod: AccountSignInMethod;
  hasPasskey: boolean;
  emailVerified: boolean;
  /** Newest refresh-token creation; null when no session is on record. */
  lastSeenAt: string | null;
  lastSignInMethod: AccountLastSignInMethod | null;
  scheduledDeletionAt: string | null;
  organizations: AdminAccountOrganization[];
  appleSubscriptions: AdminAccountSubscription[];
  isAdmin: boolean;
}

export interface AccountListParams {
  search?: string;
  signIn?: AccountSignInFilter;
  sort?: AccountSortField;
  order?: AccountSortOrder;
  page?: number;
  limit?: number;
}

export interface AccountListResult {
  items: AdminAccountRow[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

/**
 * GET /admin/users — every Check ID account (not the newsletter list), with
 * search by email, name or exact account ID.
 */
export function listAccounts(params: AccountListParams = {}): Promise<AccountListResult> {
  return apiGet<AccountListResult>('/admin/users', params);
}

/** GET /admin/users/:id — one account; the API answers 400 for a non-UUID and 404 for a miss. */
export function getAccount(id: string): Promise<AdminAccountRow> {
  return apiGet<AdminAccountRow>(`/admin/users/${encodeURIComponent(id)}`);
}
